import { API_URL } from "constants/ApiUrl";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Col, Row, Spinner } from "reactstrap";

const AgentInfo = () => {
    const { t } = useTranslation();
    const { agent, loading } = useSelector((state) => state.Agent);

    if (loading) {
        return (
            <div style={{ textAlign: "center", padding: "20px" }}>
                <Spinner color="primary" />
                <div>{t("profile.agentInfo.loading") || "Chargement en cours..."}</div>
            </div>
        );
    }
    const [licenceDoc, setlicenceDoc] = useState(null);
    useEffect(() => {
        // if (agent?.licenseDocument) {
        //     const cleanApiUrl = API_URL.replace(/\/+$/, '');
        //     let cleandoc = agent.licenseDocument.replace(/^\/+/, '');
        //     if (!cleandoc.includes('uploads/')) {
        //         cleandoc = 'uploads/' + cleandoc;
        //     }
        //     setlicenceDoc(`${cleanApiUrl}/${cleandoc}`);
        // }
        if (agent?.licenseDocument) {
            const cleanApiUrl = API_URL.replace(/\/+$/, '');

            let cleandoc = agent?.licenseDocument.replace(/\\/g, '/').replace(/^\/+/, '');

            if (!cleandoc.startsWith('uploads/')) {
                cleandoc = 'uploads/' + cleandoc;
            }
            setlicenceDoc(`${cleanApiUrl}/${cleandoc}`);
        }
    }, [agent])

    return (
        <Row className="d-flex justify-content-center" style={{ marginTop: 30 }}>
            <Col md="10">
                <Row>
                    {/* Première Colonne : informations personnelles */}
                    <Col md={5}>
                        <div style={styles.infoProfile}>
                            <span style={styles.titreInfo}>
                                {t("profile.agentInfo.firstName")}:{" "}
                            </span>
                            {agent?.firstName}
                        </div>
                        <div style={styles.infoProfile}>
                            <span style={styles.titreInfo}>
                                {t("profile.agentInfo.lastName")}:{" "}
                            </span>
                            {agent?.lastName}
                        </div>
                        <div style={styles.infoProfile}>
                            <span style={styles.titreInfo}>
                                {t("profile.agentInfo.userName")}:{" "}
                            </span>
                            {agent?.userName}
                        </div>
                        <div style={styles.infoProfile}>
                            <span style={styles.titreInfo}>
                                {t("profile.agentInfo.country")}:{" "}
                            </span>
                            {agent?.country}
                        </div>
                        <div style={styles.infoProfile}>
                            <span style={styles.titreInfo}>
                                {t("profile.agentInfo.licenseNumber")}:{" "}
                            </span>
                            {agent?.licenseNumber}
                        </div>
                    </Col>

                    {/* Deuxième Colonne : contacts et document de licence */}
                    <Col md={7} style={{ position: "relative" }}>
                        <div style={styles.infoProfile}>
                            <span style={styles.titreInfo}>
                                {t("profile.agentInfo.email")}:{" "}
                            </span>
                            {agent?.email}
                        </div>
                        <div style={styles.infoProfile}>
                            <span style={styles.titreInfo}>
                                {t("profile.agentInfo.phone")}:{" "}
                            </span>
                            {agent?.phone}
                        </div>
                        <div style={styles.infoProfile}>
                            <span style={styles.titreInfo}>
                                {t("profile.agentInfo.licenseDocument")}:{" "}
                            </span>
                            {agent?.licenseDocument ? (
                                <a href={licenceDoc} target="_blank" rel="noopener noreferrer">
                                    {t("profile.agentInfo.viewLicense") || "Voir le document"}
                                </a>
                            ) : (
                                t("profile.agentInfo.noLicenseDocument") ||
                                "Aucun document de licence"
                            )}
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

const styles = {
    titreInfo: {
        color: "#000000",
        fontWeight: "bold",
    },
    infoProfile: {
        marginBottom: "35px",
        fontSize: "18px",
        fontFamily: "Poppins, sans-serif",
    },
};

export default AgentInfo;